// imports for WebPack
import '../styles/style.scss';
// import './dev/malt-tools'
import HeaderHeight from './components/HeaderHeight';
import Facets from './components/Facets';
// import Fancybox from './components/Fancybox'
import Filters from './components/Filters';
import Sliders from './components/Flickity-sliders';
import Hamburger from './components/Hamburger';
import Header from './components/Header';
import Footer from './components/Footer';
import SetPasswordForm from './components/SetPasswordForm';
import RoomRates from './components/RoomRates';
import GravityForms from './components/GravityForms';
import SuperScroll from './components/SuperScroll';
import ClosebyMap from './components/ClosebyMap';
import PasswordValidation from './components/PasswordValidation';
import ImageReveal from './components/ImageReveal';
import Masonry from './components/Masonry';
import HeroSlider from './components/HeroSlider';
import CardSlider from './components/CardSlider';
import Accordion from '../../malt-blocks/accordion/accordion';
import LogoAnimation from './components/LogoAnimation';
import VideoControl from './components/VideoControl';
import TextAnimation from './components/TextAnimation';
import DynamicImage from './components/DynamicImage';
import DataLayer from './components/DataLayer';
import DropdownMenu from './components/DropdownMenu';

require.context('../images/', true);

Hamburger.init();
HeaderHeight.init();
Header.init();
Footer.init();
// Fancybox.init()
Sliders.init();
SetPasswordForm.init();
Facets.init();
Filters.init();
GravityForms.init();
RoomRates.init();
PasswordValidation.init();
Accordion.init();
//ImageReveal.init(); // "Joel look here for Image Reveal using Gsap, this was working with left to right reveal, but I tried to use it on a button, and it broke, but its left here for future"
SuperScroll.init();
Masonry.init();
ClosebyMap.init();
HeroSlider.init();
CardSlider.init();
LogoAnimation.init();
VideoControl.init();
// TextAnimation.init();
DataLayer.init();
DynamicImage.init();
DropdownMenu.init();
